import { useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';

import Button from '@/components/Button';
import Modal from '@/components/Modals/Modal';

interface NotAllSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  orders: string[];
}

const NotAllSuccessModal = ({ isOpen, onClose, orders }: NotAllSuccessModalProps) => {
  const theme = useTheme();

  return (
    <Modal
      maxWidth="lg"
      isOpen={isOpen}
      onClose={onClose}
      title="Algunas guías no pudieron generarse"
      actions={
        <Button variant="contained" onClick={onClose}>
          Aceptar
        </Button>
      }
    >
      <Typography
        variant="body1"
        sx={{
          padding: '1rem',
          color: theme.palette.grey[500],
          textAlign: 'center',
        }}
      >
        Las siguientes órdenes no fueron procesadas correctamente:
      </Typography>

      <ul
        style={{
          marginTop: '1rem',
          textAlign: 'start',
          width: '80px',
          margin: '0 auto',
        }}
      >
        {orders.map((order) => (
          <li key={order} style={{ textAlign: 'left', color: theme.palette.grey[400] }}>
            #{order}
          </li>
        ))}
      </ul>

      <Typography
        variant="body2"
        sx={{
          paddingTop: '2rem',
          color: theme.palette.grey[400],
          textAlign: 'center',
          fontStyle: 'italic',
        }}
      >
        Revisa que cuenten con todos los datos necesarios o vuelve a intentarlo más tarde.
      </Typography>
    </Modal>
  );
};

export default NotAllSuccessModal;
